import { Button, ChevronLeftIcon, TopNavigationBar } from "@mychili/clarity-ui";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useOrder } from "../../../entities/order";
import { LanguageSwitcher } from "../../../features/language-switcher";
import { isMobile } from "../../../shared/lib/device";

type LayoutMainProps = {
  children?: ReactNode;
};

export const LayoutMain = ({ children }: LayoutMainProps) => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const onlineOrderId = searchParams.get("onlineOrderId") ?? undefined;

  const { data } = useOrder({
    onlineOrderId,
  });

  const handleBackButtonClick = () => {
    const redirectUrl =
      data?.redirect_urls?.cart_redirect_url ?? data?.website_url;

    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      navigate(-1);
    }
  };

  const showBackButton =
    data?.online_order_status === "PAYMENT_IN_PROGRESS" &&
    !data?.is_mobile_integration;

  return (
    <div className="flex h-screen flex-col">
      <TopNavigationBar className="mx-5 flex max-w-full! justify-between">
        <div className="flex w-full items-center justify-between">
          {showBackButton ? (
            <div>
              <Button
                variant="transparent"
                onClick={handleBackButtonClick}
                className="pl-0"
              >
                <ChevronLeftIcon />
                {t("topbar.back_button_text")}
              </Button>
            </div>
          ) : null}

          {isMobile ? null : (
            <img
              className="-translate-x-1/2 absolute left-1/2 h-9"
              src="https://static.ahapay.my/logos/full.svg"
              alt="logo"
            />
          )}

          <div className="flex items-end">
            <LanguageSwitcher />
          </div>
        </div>
      </TopNavigationBar>

      <div className="flex h-[calc(100dvh-68px)] flex-col items-center justify-center bg-background-neutral-subtler">
        {children}
      </div>
    </div>
  );
};
